// client/menu-items/EditGlobalSettings.ts
import "@adornis/chemistry/elements/components/x-icon";
import { GlobalSettingsDrawerPanel } from "../global-settings-drawer-panel.js";
var EditGlobalSettingsMenuItem = (globalSettingsClassName) => {
  return {
    label: "Globale Einstellungen",
    icon: "settings",
    run: (view) => {
      return GlobalSettingsDrawerPanel.showPopup({ modal: true, props: { globalSettingsClassName } });
    }
  };
};
export {
  EditGlobalSettingsMenuItem
};
